<div class="irembogov-service-change-requests-list-table-widget">
  <div
    class="d-flex justify-content-between gap-2 align-items-end search-filters">
    <div class="d-flex flex-column align-items-stretch search-field">
      <label> {{ 'Search for service' }} </label>
      <label class="search-field-control-label" for="searchFieldControl">
        <input
          id="searchFieldControl"
          type="input"
          class="form-control form-control-lg d-flex form-control-sm search-field-control"
          placeholder="{{ 'Search' }}"
          [formControl]="serviceNameFilter" />
        <i
          class="icon-x pointer-cursor search-field-clear"
          *ngIf="serviceNameFilter.value"
          (click)="serviceNameFilter.setValue(null)"
          (keypress)="serviceNameFilter.setValue(null)"></i>
      </label>
    </div>
    <div class="d-flex flex-column align-items-stretch organization-field">
      <label> {{ 'Filter by organization' }} </label>
      <irembogov-select-paginated
        placeholder="Filter by organization"
        bindLabel="name"
        (searchItem)="getOrganizationsFilterList($event, true)"
        [loading]="isLoadingOrganizationFilterList"
        [formControl]="institutionFilter"
        [searching]="true"
        [items]="organizationFilterList"
        (loadMoreItems)="
          loadMoreOrganizationsFilterList()
        "></irembogov-select-paginated>
    </div>
    <div class="d-flex flex-column align-items-stretch sort-field">
      <label> {{ 'Sort by' }} </label>
      <select
        [(ngModel)]="selectedSortOptionIndex"
        (ngModelChange)="updateSort($event)"
        class="form-select form-select-lg sort-control">
        <option
          [value]="i"
          *ngFor="let item of sortFieldOptions; let i = index">
          {{ item.label }}
        </option>
      </select>
    </div>
  </div>

  <irembogov-irembo-section-message
    type="info"
    *ngIf="!isLoadingChangeRequestList && collectionSize < 1"
    class="w-80 mx-auto mt-5 d-block"
    title=""
    [message]="
      changeRequestStatus === EServiceChangeRequestStatus._UNKNOWN_
        ? 'You have\'nt been assigned a service yet' +
          generateEmptyChangeRequestExtraMessage()
        : 'No assigned service in ' +
          (changeRequestStatus | changeRequestStatusToLabel | uppercase) +
          generateEmptyChangeRequestExtraMessage()
    "
    [dismissible]="false">
  </irembogov-irembo-section-message>

  <div class="container-fluid my-3 p-0">
    <div class="row mt-4">
      <div class="col-12">
        <div class="table-responsive">
          <table
            class="table table-borderless mb-0"
            [ngClass]="{
              'skeleton-container':
                isLoadingChangeRequestList || isLoadingOrganizationList
            }"
            aria-label="Irembo Service Change Requests Table">
            <thead class="bg-light rounded">
              <tr>
                <th class="t-header" scope="col" style="width: 20%">
                  Service Name
                </th>
                <th class="t-header" scope="col" style="width: 18%">
                  Organization
                </th>
                <th class="t-header" scope="col">Type</th>
                <th class="t-header" scope="col">Status</th>
                <th class="t-header" scope="col">Created Date</th>
                <th class="t-header" scope="col">Requirement Doc Link</th>
                <th class="t-header" scope="col">Action</th>
                <th class="t-header" scope="col">Debug Mode</th>
              </tr>
            </thead>
            <tbody
              *ngIf="isLoadingChangeRequestList || isLoadingOrganizationList">
              <ng-container *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
                <tr class="border-bottom">
                  <td>
                    <div class="skeleton-box" style="width: 80%"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 120px"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 80px"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 80px"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 90px"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 120px"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 80px"></div>
                  </td>
                  <td>
                    <div class="skeleton-box" style="width: 40px"></div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
            <tbody
              class="rounded bg-white"
              *ngIf="!isLoadingChangeRequestList && !isLoadingOrganizationList">
              <tr
                class="border-bottom"
                *ngFor="let changeRequest of changeRequestList; index as index">
                <td>
                  <irembogov-table-inline-user-info
                    [name]="changeRequest.serviceName"
                    [nameAsUpperCase]="false"
                    [showThumbnail]="false"
                    [nameActiveLink]="false"
                    [namePointerCursor]="false"
                    [emailActiveLink]="false"
                    [emailPointerCursor]="false">
                  </irembogov-table-inline-user-info>
                </td>
                <td class="text-wrap">
                  {{ changeRequest?.organization?.name || 'N/A' }}
                </td>
                <td class="text-nowrap">
                  <irembogov-service-change-request-type-badge
                    [requestType]="
                      changeRequest.type
                    "></irembogov-service-change-request-type-badge>
                </td>
                <td class="text-nowrap">
                  <irembogov-service-change-request-status-badge
                    [requestStatus]="
                      changeRequest.status
                    "></irembogov-service-change-request-status-badge>
                </td>
                <td>
                  <irembogov-table-inline-user-info
                    name="{{ changeRequest.dateCreated | date : 'dd/MM/yyyy' }}"
                    [nameAsUpperCase]="false"
                    [showThumbnail]="false"
                    [nameActiveLink]="false"
                    [namePointerCursor]="false"
                    [emailActiveLink]="false"
                    [emailPointerCursor]="
                      false
                    "></irembogov-table-inline-user-info>
                </td>
                <td class="text-wrap">
                  <span class="text-primary text-decoration-underline">
                    <em> Requirement Doc. </em>
                    <i class="fas fa-file-download"></i>
                  </span>
                </td>
                <td class="text-nowrap">
                  <irembogov-service-change-request-reviewer-action-widget
                    *ngIf="
                      viewAsRole === RolesEnum.ROLE_QA_REVIEWER &&
                      changeRequest.status === EServiceChangeRequestStatus.IN_QA
                    "
                    [changeRequest]="changeRequest"
                    (OnReviewClicked)="
                      onReviewRequestClick($event)
                    "></irembogov-service-change-request-reviewer-action-widget>

                  <irembogov-service-change-request-configurer-action-widget
                    (OnConfigureClicked)="onConfigureRequestClick($event)"
                    [changeRequest]="changeRequest"
                    *ngIf="
                      viewAsRole === RolesEnum.ROLE_SERVICE_MANAGER &&
                      (changeRequest.status ===
                        EServiceChangeRequestStatus.IN_DEVELOPMENT ||
                        changeRequest.status ===
                          EServiceChangeRequestStatus.IN_REDEVELOPMENT)
                    "></irembogov-service-change-request-configurer-action-widget>

                  <irembogov-service-change-request-viewer-action-widget
                    (OnViewClicked)="onViewRequestClick($event)"
                    [changeRequest]="changeRequest"
                    *ngIf="
                      viewAsRole === RolesEnum.ROLE_SERVICE_MANAGER &&
                      changeRequest.status !==
                        EServiceChangeRequestStatus.IN_DEVELOPMENT &&
                      changeRequest.status !==
                        EServiceChangeRequestStatus.IN_REDEVELOPMENT &&
                      changeRequest.status !==
                        EServiceChangeRequestStatus._UNKNOWN_
                    "></irembogov-service-change-request-viewer-action-widget>
                </td>
                <td class="text-nowrap">
                  <irembogov-basic-toggle-switch
                    [uniqueId]="'debug-switch-' + changeRequest.id"
                    (switchChanged)="
                      onToggleDebugMode($event, changeRequest.id)
                    "
                    [checked]="changeRequest.debugMode"
                    [disabled]="
                      changeRequest.status ===
                        EServiceChangeRequestStatus.REJECTED_REVIEW ||
                      changeRequest.status ===
                        EServiceChangeRequestStatus.WAITING_APPROVER ||
                      changeRequest.status ===
                        EServiceChangeRequestStatus.CANCELED_REQUEST
                    "></irembogov-basic-toggle-switch>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="border-top">
                <td colspan="8">
                  <!-- Pagination -->
                  <irembogov-inline-pagination
                    *ngIf="
                      !isLoadingChangeRequestList &&
                      changeRequestList.length > 0
                    "
                    [minimalPagination]="false"
                    [showDirectionText]="true"
                    [collectionSize]="collectionSize"
                    [pageSize]="(_filterObject | async)?.size || 10"
                    [page]="((_filterObject | async)?.page || 0) + 1"
                    (paginatedValues)="
                      updateApiFilter(_filterObject, {
                        page: $event.pageNumber - 1,
                        size: $event.pageSize
                      })
                    "></irembogov-inline-pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
